import Bowser from 'bowser';

type OS = 'macOS' | 'Windows' | 'Chrome OS' | 'Linux' | 'other';

export const getOS = async (): Promise<OS > => {
  if (typeof window !== 'undefined') {
    const browser = Bowser.getParser(window.navigator.userAgent);
    return Promise.resolve(browser.getOSName() as OS);
  }

  const { os } = await new Promise((resolve) => {
    chrome.runtime.getPlatformInfo(resolve);
  });

  // "mac", "win", "android", "cros", "linux", or "openbsd"
  return (
    {
      mac: 'macOS',
      win: 'Windows',
      cros: 'Chrome OS',
      linux: 'Linux',
    }[os] || 'other'
  );
};

export const createUserId = (): string => {
  if (typeof crypto === 'undefined') return null;
  const randomPool = new Uint8Array(32);
  crypto.getRandomValues(randomPool);
  let hex = '';
  for (let i = 0; i < randomPool.length; ++i) {
    hex += randomPool[i].toString(16);
  }
  return hex;
};

export const pause = (timeout: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, timeout));

export const timeInMs = (() => {
  const second = 1000;
  const minute = second * 60;
  const hour = minute * 60;
  const day = hour * 24;
  const week = day * 7;
  const month = day * 30;

  return { second, minute, hour, day, week, month };
})();

type PotentialDate = number | string | Date;

export const toDayFormat = (date: PotentialDate): string => new Date(date).toISOString().split('T')[0];

export const isSameDay = (date1: PotentialDate, date2: PotentialDate = Date.now()): boolean =>
  toDayFormat(date1) === toDayFormat(date2);

export const timeoutSignal = (timeout: number): AbortSignal => {
  const controller = new AbortController();
  setTimeout(() => controller.abort(), timeout);
  return controller.signal;
};
